/* global Alpine */

/**
 * Componente Alpine leggero per la pagina Carrello: gestisce solo il modale dettagli transfer.
 * I dati vengono renderizzati server-side, questo componente gestisce solo le interazioni JS.
 */
export default function cartPage() {
  document.addEventListener('alpine:init', () => {
    Alpine.data('cartPage', () => ({
      showTariffModal: false,
      selectedTariff: null,

      /** Stringhe tradotte (da data-cart-strings se presente) */
      strings: {},

      /** Configurazione tariffe dal server (da data-tariff-config) */
      tariffConfig: {},

      init() {
        const raw = this.$el.getAttribute('data-cart-strings')
        if (raw) {
          try {
            this.strings = JSON.parse(raw)
          } catch {
            this.strings = {}
          }
        }
        const rawConfig = this.$el.getAttribute('data-tariff-config')
        if (rawConfig) {
          try {
            this.tariffConfig = JSON.parse(rawConfig)
          } catch {
            this.tariffConfig = {}
          }
        }
      },

      /** Apre il modale con i dettagli del transfer selezionato (da elemento DOM) */
      openTariffModalFromElement(element) {
        const itemJson = element.getAttribute('data-item')
        if (!itemJson) return
        let item
        try {
          item = JSON.parse(itemJson)
        } catch {
          return
        }
        this.openTariffModal(item)
      },

      /** Apre il modale con i dettagli del transfer selezionato */
      openTariffModal(item) {
        const liveQuote = item.live_quote || {}
        const payloadJson = item.payload_json || '{}'
        let payload = {}
        try {
          payload = JSON.parse(payloadJson)
        } catch {
          // Ignora errore parsing
        }

        // Determina il tipo di tariffa selezionata
        const priceType = payload.price_type || 'economy'
        const prices = liveQuote.price || {}
        const selectedPrice =
          prices[priceType] ||
          prices.economy ||
          prices.exclusive ||
          prices.luxury

        if (!selectedPrice) {
          alert('Dettagli tariffa non disponibili.')
          return
        }

        // Prepara i dati della tariffa nel formato atteso dal modale
        const transfer = item.transfer || {}
        const from = liveQuote.from || {}
        const to = liveQuote.to || {}
        const pickup = liveQuote.pickup || {}

        // Configurazione tariffe (dal server via data-tariff-config, con fallback)
        const serverConfig =
          this.tariffConfig[priceType] || this.tariffConfig.economy || {}
        const config = {
          icon: serverConfig.icon || 'car',
          label:
            serverConfig.label ||
            priceType.charAt(0).toUpperCase() + priceType.slice(1),
          description: serverConfig.description || '',
          notes: serverConfig.notes || '',
        }

        this.selectedTariff = {
          type: priceType,
          icon: config.icon,
          label: config.label,
          description: config.description,
          formattedPrice: new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(selectedPrice.amount || 0),
          distance: liveQuote.distance
            ? `${Number(liveQuote.distance.km).toLocaleString('it-IT', {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
              })} km`
            : '—',
          duration: liveQuote.duration?.human || '—',
          pax: transfer.pax || item.pax || '—',
          bags: transfer.bags || item.bags || 0,
          from: from.name || '—',
          from_address: from.address || '',
          to: to.name || '—',
          to_address: to.address || '',
          date: pickup.date || transfer.date || '—',
          time: pickup.time || transfer.time || '—',
          notes: [
            ...(config.notes ? [config.notes] : []),
            ...(selectedPrice.notes || []),
          ],
          cancellation_policy: selectedPrice.cancellation_policy || null,
        }

        this.showTariffModal = true
        document.body.style.overflow = 'hidden'
      },

      closeTariffModal() {
        this.showTariffModal = false
        this.selectedTariff = null
        document.body.style.overflow = ''
      },

      formatCancellationPolicy(policy) {
        const s = this.strings
        if (!policy)
          return {
            type: 'unknown',
            text: s.cancellationUnknown || 'Informazioni non disponibili',
          }

        if (!policy.refundable) {
          return {
            type: 'non-refundable',
            icon: 'circle-xmark',
            color: 'red',
            title: s.nonRefundable || 'Non rimborsabile',
            text:
              s.nonRefundableDesc || 'Questa prenotazione non è rimborsabile.',
          }
        }

        const deadline = new Date(policy.penalty_datetime)
        const deadlineStr = deadline.toLocaleDateString('it-IT', {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })

        if (policy.penalty_datetime && deadline <= new Date()) {
          return {
            type: 'deadline-passed',
            icon: 'circle-info',
            color: 'yellow',
            text:
              s.nonRefundableWithin24h ||
              'Prenotazione non rimborsabile in quanto a meno di 24 ore',
          }
        }

        if (policy.penalty_amount === 0) {
          return {
            type: 'full-refund',
            icon: 'circle-check',
            color: 'green',
            title: s.cancelFree || 'Cancellazione gratuita',
            text: `${s.cancelFreeBy || 'Cancella gratuitamente entro'} ${deadlineStr}. ${s.cancelFreeAfter || 'Dopo questa data non sarà possibile ottenere alcun rimborso.'}`,
          }
        }

        return {
          type: 'partial-refund',
          icon: 'circle-info',
          color: 'yellow',
          title: s.cancelPenalty || 'Cancellazione con penale',
          text: `${s.cancelBy || 'Cancella entro'} ${deadlineStr} ${s.cancelPenaltyWith || 'con una penale di'} €${policy.penalty_amount.toFixed(2)}. ${s.cancelFreeAfter || 'Dopo questa data non sarà possibile ottenere alcun rimborso.'}`,
        }
      },
    }))
  })
}
